import React, { useEffect, useState } from "react";
import { Tooltip, Box, Typography, IconButton, Button } from '@mui/material';
import Card from "../../components/card/Card";
import ActionButton from "../../components/actionButton";
import TableContainer from "../../components/table/table";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllPharmacy } from "../../store/actions/pharmacy";
import PermissionComp, { useHasPermission } from "../../components/permissionComp/permissionComp";
import { getAllVendor, updateVendor } from "../../store/actions/vendor";
import ModalButton from "../../components/modalButton/modalButton";
import VendorForm from "./vendorForm";
import edit from '../../assets/edit.png'
import IsDeleteModal from "../../components/isDelete";
import { deleteRecord, updateRecord } from "../../store/reducers/vendor-slice";


const Vendor = () => {
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const navigation = useNavigate()
    const { vendor } = useSelector(state => state.vendor)
    const { user } = useSelector(state => state.auth)
    const [Vendors, setVendors] = useState([])
    const [open, setOpen] = React.useState(false);

    const tableHeader = ['Vendor Name', 'Abbrevation', 'Email', 'Phone', 'Company']
    const verifyParam = ['vendorName', 'abbrevation', 'emailAddress', 'phone', 'companyName']

    useEffect(() => {
        setIsLoading(true)
        let data = {
            "sid": null,
            "lid": null,
            "reqInfo": null,
            "msgType": "GETALLVENDOR",
            "data": { "Company_ID": user?.businessId },
            "debug": null,
            "token": null
        }
        dispatch(getAllVendor(data)).then(res => {
            setIsLoading(false)
        })
    }, [])

    useEffect(() => {
        let arr = []
        vendor.forEach((ele) => {
            const obj = { ...ele }
            obj['isActive'] = obj.isActive ? "Active" : obj.isActive ? "Non-Active" : '';
            arr.push(obj)
        })
        setVendors(arr)

    }, [vendor])

    const deleteVendor = (data) => {
        let obj = {
            "VendorName": null,
            "EmailAddress": null,
            "Website": null,
            "Phone": null,
            "Abbrevation": null,
            "Address": null,
            "Company_ID": null,
            "CountryID": null,
            "StateID": null,
            "City_ID": null,
            "ID": data.id,
            "EditBy": user?.userId,
            "ISUPDATE": 0,
        }
        let sentObj = {
            "sid": null,
            "lid": null,
            "reqInfo": null,
            "msgType": "UPDATEVENDOR",
            "data": obj,
            "debug": null,
            "token": null
        }

        dispatch(updateVendor(sentObj)).then(res => {
            setIsLoading(false)
            dispatch(deleteRecord(obj))
            setOpen(false)
        })
    }

    const hasPermission = useHasPermission(['Vendor', 'edit'])

    return (
        <>
            <Box sx={{ margin: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant='h1' >Vendor</Typography>
                <PermissionComp list={['Vendor', 'create']}>
                    <ModalButton open={open} setOpen={setOpen} tooltip={'Create Vendor'} type={'Button'}>
                        <VendorForm setOpen={setOpen} />
                    </ModalButton>
                </PermissionComp>
            </Box>
            <Card style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <TableContainer tableHeader={tableHeader}
                    data={Vendors}
                    verifyParam={verifyParam}
                    isLoading={isLoading}
                    action={(data) => <TableAction id={data.id} deleteRecord={deleteVendor} />} />
            </Card>
        </>
    );
};

export default Vendor;



const TableAction = ({ id, deleteRecord }) => {
    const [openEdit, setOpenEdit] = React.useState(false);

    return (
        <>
            <PermissionComp list={['Vendor', 'edit']}>
                <ModalButton open={openEdit} setOpen={setOpenEdit} tooltip={'Edit Vendor'} img={edit} type={'icon'}>
                    <VendorForm data={id} setOpen={setOpenEdit} />
                </ModalButton>
            </PermissionComp>
            <PermissionComp list={['Vendor', 'delete']}>
                <IsDeleteModal onPress={() => deleteRecord(id)} />
            </PermissionComp>
        </>
    )
}
